<script setup lang="ts">
/** Appointment of DPO (B32116) — 문서 패키지(1부: 결의 + 위임장). */
import { ref } from 'vue';
import AppointDpoDoc from './AppointDpoDoc.vue';

withDefaults(defineProps<{ soleDirector?: boolean; gender?: string }>(), { soleDirector: false, gender: 'M' });
const emit = defineEmits<{ (e: 'update:gender', v: string): void }>();

const ZOOM_MIN = 100, ZOOM_MAX = 175, ZOOM_STEP = 25;
const docZoom = ref(100);
function setZoom(n: number) { docZoom.value = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, Math.round(n / ZOOM_STEP) * ZOOM_STEP)); }
</script>

<template>
  <div class="dpo-pkg">
    <div class="zoom-bar">
      <div class="doc-zoom">
        <button type="button" class="doc-zoom-btn" :disabled="docZoom <= ZOOM_MIN" @click="setZoom(docZoom - ZOOM_STEP)">A−</button>
        <button type="button" class="doc-zoom-pct" @click="setZoom(100)">{{ docZoom }}%</button>
        <button type="button" class="doc-zoom-btn" :disabled="docZoom >= ZOOM_MAX" @click="setZoom(docZoom + ZOOM_STEP)">A+</button>
      </div>
    </div>

    <div class="paper-zoom" :style="{ zoom: docZoom / 100 }">
      <div class="pkg-doclabel">
        <span class="ic">📝</span><span class="nm">Appointment of DPO — Directors' Resolutions &amp; Letter of Authorisation</span>
        <span class="no">Doc 1 / 1</span>
      </div>
      <div class="simple-frame">
        <AppointDpoDoc :sole-director="soleDirector" :gender="gender" @update:gender="(v) => emit('update:gender', v)" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.dpo-pkg { color: #111; }
.zoom-bar { display: flex; justify-content: flex-end; align-items: center; gap: 10px; width: 794px; max-width: 100%; margin: 0 auto 18px; }
.doc-zoom { display: inline-flex; align-items: center; gap: 2px; background: #f2f4f6; border-radius: 10px; padding: 2px; }
.doc-zoom-btn, .doc-zoom-pct { border: none; background: transparent; cursor: pointer; font-weight: 800; color: #4b5563; border-radius: 8px; height: 32px; }
.doc-zoom-btn { min-width: 36px; font-size: 15px; }
.doc-zoom-btn:disabled { opacity: 0.35; cursor: default; }
.doc-zoom-pct { min-width: 52px; font-size: 12px; color: #3182f6; }
.paper-zoom { width: 794px; max-width: 100%; margin: 0 auto; }
.pkg-doclabel { display: flex; align-items: center; gap: 8px; padding: 0 4px 12px; }
.pkg-doclabel .ic { font-size: 14px; }
.pkg-doclabel .nm { font-size: 12.5px; font-weight: 800; color: #42506a; }
.pkg-doclabel .no { margin-left: auto; font-size: 10.5px; font-weight: 800; color: #9aa6bd; white-space: nowrap; }
.simple-frame { width: 100%; background: #fff; border: 1px solid #e2e5ea; box-shadow: 0 4px 20px rgba(20,30,60,0.09); padding: 32px; box-sizing: border-box; overflow: hidden; font-size: 12px; }
</style>
